import React, { Component, type ErrorInfo, type PropsWithChildren } from 'react'
import { logAppError } from '@shared/pipes/log-app-error'
import { AppError } from 'screens/app-error'

type State = {
	hasError: boolean
}

export class AppErrorBoundary extends Component<PropsWithChildren, State> {
	state: State = {
		hasError: false,
	}

	static getDerivedStateFromError(): State {
		return { hasError: true }
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
		logAppError(error, {
			source: 'error-boundary',
			componentStack: errorInfo.componentStack,
		})
	}

	render() {
		if (this.state.hasError) {
			return <AppError />
		}

		return this.props.children
	}
}
